<template>
  <div v-scrollanimation class="TextField">
    <Image
      class="wide shadow"
      v-if="imagePlacement === 'top'"
      :imageId="imageId"
    />
    <div className="Paragraph">
      <Image
        class="ParagraphImage shadow Left"
        v-if="imagePlacement === 'left'"
        :imageId="imageId"
      />
      <div className="Description">
        <Editor :textId="textId" />
      </div>
      <Image
        class="ParagraphImage shadow Right"
        v-if="imagePlacement === 'right'"
        :imageId="imageId"
      />
    </div>
    <div v-if="isAdmin" class="closeIconWrapper">
      <button @click="onDeleteTextField">Ta bort</button>
    </div>
  </div>
</template>

<script>
import Editor from '@/Components/Editor.vue';
import Image from '@/Components/Image.vue';
import { updateTextField, deleteTextField, deleteText } from '@/firebase';
import Cookies from "js-cookie";

export default {
  setup() {},
  props: {
    type: {
      type: String,
      required: true,
    },
    textFieldId: {
      type: String,
      required: true,
    },
    imagePlacement: {
      type: String,
      required: true,
    },
    textId: {
      type: String,
      required: true,
    },
    imageId: {
      type: String,
      required: true,
    },
    timestamp: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isAdmin: Cookies.get("user") ? true : false,
    }
  },
  components: {
    Editor,
    Image,
  },
  methods: {
    updateImageId(updatedImageId) {
      updateTextField(this.type, this.textFieldId, {
        imageId: updatedImageId,
        imagePlacement: this.imagePlacement,
        textId: this.textId,
        timestamp: this.timestamp,
      });
    },
    async onDeleteTextField() {
      await deleteTextField(this.type, this.textFieldId);
      await deleteText(this.textId);
      this.$parent.deletedTextField();
    },
  },
};
</script>

<style scoped>
button {
  margin-top: 20px;
}
.TextField {
  margin: 50px auto;
}
.wide {
  width: 90%;
  margin: 0px auto 20px;
  max-width: 1000px;
  height: 400px;
  object-fit: cover;
}
.ParagraphImage {
  width: 40vw;
  height: 600px;
  object-fit: cover;
}
.Paragraph {
  width: 85vw;
  max-width: 1000px;
  margin: auto;
  display: flex;
  align-items: center;
}
.Description {
  width: 45vw;
  max-width: 550px;
}
.Left {
  margin-right: 4vw;
}
.Right {
  margin-left: 4vw;
}
.closeIconWrapper {
  color: black;
  text-align: right;
  width: 85vw;
  margin: auto;
}
</style>
